import React, { useState, useEffect, useRef } from "react";
import "./ecommerce.scss";
import deleteIcon from "../../images/delete.svg";

const CartItem = ({ item, updateCartPrice, updateProductSize, updateProductPharmacy, deleteCartItem, readOnly, isError }) => {
    const [pricedropdown, setPricedropdown] = useState(false);
    const [sizedropdown, setSizedropdown] = useState(false);
    const [pharmaciesdropdown, setPharmaciesdropdown] = useState(false);

    const priceRef = useRef(null);
    const sizeRef = useRef(null);
    const pharmacyRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (priceRef.current && !priceRef.current.contains(event.target)) {
                setPricedropdown(false);
            }
            if (sizeRef.current && !sizeRef.current.contains(event.target)) {
                setSizedropdown(false);
            }
            if (pharmacyRef.current && !pharmacyRef.current.contains(event.target)) {
                setPharmaciesdropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <li className="cart-item">
            <div className="card-thumb">
                <img src={item.ThumbnailURL} alt={item.ProductName} />
            </div>
            <div className="card-content">
                <h4><span>{item.ProductName}</span>{!readOnly ? <div className="deleteicon" onClick={() => deleteCartItem(item.ProductID)}><img src={deleteIcon} /></div> : null}</h4>
                <div className="cart-dropdowns">
                    {item.Prices && item.Prices.length ? (
                        <div className={`price-dropdown-wrapper ${readOnly ? 'disabled' : ''}`} ref={priceRef}>
                            <div className="price-dropdown-header" onClick={() => setPricedropdown(!pricedropdown)}>
                                <span>${item.selectedPrice?.QuantityPrice} - <span>{item.selectedPrice?.QuantityThreshold}</span></span>
                            </div>
                            {pricedropdown && (
                                <ul className="price-dropdown">
                                    {item.Prices.map((price, index) => (
                                        <li key={index} onClick={() => {
                                            updateCartPrice(item.ProductID, price);
                                            setPricedropdown(false);
                                        }}>
                                            <span>${price.QuantityPrice}</span> - <span>{price.QuantityThreshold}</span>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ) : null}

                    {item.Sizes && item.Sizes.length ? (
                        <div className={`price-dropdown-wrapper size-drop-wrapper ${readOnly ? 'disabled' : ''} ${isError ? 'highlight-error' : ''}`} ref={sizeRef}>
                            <div className="price-dropdown-header" onClick={() => setSizedropdown(!sizedropdown)}>
                                {item.selectedSize ? <span>{item.selectedSize?.Size}</span> : <span>Select Size</span>}
                            </div>
                            {sizedropdown && (
                                <ul className="price-dropdown">
                                    {item.Sizes.map((size, index) => (
                                        <li key={index} onClick={() => {
                                            updateProductSize(item.ProductID, size);
                                            setSizedropdown(false);
                                        }}>
                                            <span>{size.Size}</span>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ) : null}

                    {item.Pharmacies && item.Pharmacies.length ? (
                        <div className={`price-dropdown-wrapper pharmacy-drop-wrapper ${readOnly ? 'disabled' : ''} ${isError ? 'highlight-error' : ''}`} ref={pharmacyRef}>
                            <div className="price-dropdown-header" onClick={() => setPharmaciesdropdown(!pharmaciesdropdown)}>
                                {item.selectedPharmacy ? <span>{item.selectedPharmacy?.Name}</span> : <span>Select Pharmacy</span>}
                            </div>
                            {pharmaciesdropdown && (
                                <ul className="price-dropdown">
                                    {item.Pharmacies.map((pharmacy, index) => (
                                        <li key={index} onClick={() => {
                                            updateProductPharmacy(item.ProductID, pharmacy);
                                            setPharmaciesdropdown(false);
                                        }}>
                                            <span>{pharmacy.Name}</span>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ) : null}
                </div>
            </div>
        </li>
    );
};

export default CartItem;
